<template>
  <div class="container_ongoing">
    <!-- header -->
    <b-container v-if="($mq === 'mobile' || $mq === 'tablet')">
      <HeaderBackMobile :backToHome="false" leftAction="menu"/>
    </b-container>
    <b-container fluid v-else style="background-color:#F5F6F7;">
      <b-row>
        <StoreHeader/>
      </b-row>
    </b-container>
    <!-- content -->
    <b-container fluid style="max-width:1336px;min-height:300px;">
      <!-- not going -->
      <template v-if="!loading && !transactions.length">
        <b-row class="mt-5" style="min-height:300px;">
          <b-col class="text-center">
            <p>
              <font-awesome-icon style="font-size:32px;margin-right:15px;color:#525962;"
                                 :icon="['fal', 'shipping-timed']"/>
            </p>
            <p>Não existem pedidos em andamento.</p>
            <p>Para consultar seu Histórico de Pedidos<br/>e Pedidos Agendados</p>
            <p><a href="#/history" :style="{color:getCssColor('primary_bt')}"
                  style="font-weight:500;text-decoration:underline;">Clique Aqui</a></p>
          </b-col>
        </b-row>
      </template>
      <!-- loading -->
      <template v-else-if="loading">
        <b-row>
          <InnerLoading/>
        </b-row>
      </template>
      <!-- ongoing -->
      <template v-else>
        <b-row>
          <b-col cols="12" class="mt-3 mb-4 ongoing_title">
            Pedidos em Andamento
          </b-col>
        </b-row>
        <div v-for="(t, idx) in transactions" v-bind:key="idx">
          <b-row v-if="t.company_name">
            <b-col class="ongoing_title">{{t.company_name}}</b-col>
          </b-row>
          <b-row :class="{ongoing_box_openned: t.oppened, ongoing_box_closed: !t.oppened }"
                 class=" justify-content-center">
            <b-col cols="12" style="padding-top:18px;">
              <!-- realizado -->
              <b-row>
                <b-col cols="1" class="lined">
                  <div class="ongoing_done"
                       :style="{backgroundColor:isPurchaseDone(t, 2) ? getCssColor('primary_bt') : '#c0c0c0'}">
                    <font-awesome-icon style="font-size:8px;color:#ffffff;" :icon="['far', 'check']"/>
                  </div>
                </b-col>
                <b-col cols="10">
                  <b-row>
                    <b-col :class="{ongoing_title_done:isPurchaseDone(t,2), ongoing_title_not:!isPurchaseDone(t,2)}">
                      Pagamento Confirmado
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="ongoing_subtitle_done mt-2">
                      Número <i>{{t.PurchaseNumber}}</i> - {{getStatusDate(2, t, true)}}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="ongoing_subtitle_done mt-2">
                      <template v-if="t.DeliveryScheduleInfo">
                        Agendado: <i>{{t.DeliveryScheduleInfo}}</i>
                      </template>
                      <template v-else>
                        Entrega expressa
                      </template>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col @click="openDetails(t)" class="ongoing_link mt-2 mb-3"
                           :style="{color:getCssColor('primary_bt')}">Visualizar Detalhes
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <!-- Em preparo -->
              <b-row>
                <b-col cols="1" class="lined">
                  <div class="ongoing_done"
                       :style="{backgroundColor:isPurchaseDone(t, 4) ? getCssColor('primary_bt') : '#c0c0c0'}">
                    <font-awesome-icon style="font-size:8px;color:#ffffff;" :icon="['far', 'check']"/>
                  </div>
                </b-col>
                <b-col cols="10">
                  <b-row>
                    <b-col :class="{ongoing_title_done:isPurchaseDone(t,4), ongoing_title_not:!isPurchaseDone(t,4)}">Em
                      Preparo
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="ongoing_subtitle_done mt-2">{{getStatusDate(4, t, true)}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col class="ongoing_link mt-2 mb-3">
                      <button v-if="t.Status === 4 && t.ShopperId"
                              @click="$router.push({path:'/chat/channel_' + t.PurchaseNumber + '/' + t.ShopperId})"
                              :style="{backgroundColor:getCssColor('primary_bt')}"
                              style="align-items:center;" class="solid_ongoing_bt">
                        Fale com seu Personal Shopper
                        <font-awesome-icon class="bt_icon_ongoing" style="font-size:20px;color:#ffffff;"
                                           :icon="['fas', 'comment']"/>
                        <!-- div class="bullet_chat">1</div-->
                      </button>
                      <!--button v-else :style="{backgroundColor:'#c0c0c0'}"
                              style="align-items:center;" class="solid_ongoing_bt">
                        Fale com seu Personal Shopper
                        <font-awesome-icon class="bt_icon_ongoing" style="font-size:20px;color:#ffffff;"
                                           :icon="['fas', 'comment']"/>
                      </button -->
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <!-- aguardando transporte -->
              <b-row>
                <b-col cols="1" class="lined">
                  <div class="ongoing_done"
                       :style="{backgroundColor:isPurchaseDone(t, 11) ? getCssColor('primary_bt') : '#c0c0c0'}">
                    <font-awesome-icon style="font-size:8px;color:#ffffff;" :icon="['far', 'check']"/>
                  </div>
                </b-col>
                <b-col cols="10">
                  <b-row>
                    <b-col :class="{ongoing_title_done:isPurchaseDone(t,11), ongoing_title_not:!isPurchaseDone(t,11)}">
                      Aguardando Transporte
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="ongoing_subtitle_done mt-2 mb-4">{{getStatusDate(11, t, true)}}</b-col>
                  </b-row>
                </b-col>
              </b-row>
              <!-- Em Transporte or Aguardando Transporte -->
              <b-row>
                <b-col cols="1" class="lined">
                  <div class="ongoing_done"
                       :style="{backgroundColor:isPurchaseDone(t, 5) ? getCssColor('primary_bt') : '#c0c0c0'}">
                    <font-awesome-icon style="font-size:8px;color:#ffffff;" :icon="['far', 'check']"/>
                  </div>
                </b-col>
                <b-col cols="10">
                  <b-row>
                    <b-col :class="{ongoing_title_done:isPurchaseDone(t,5), ongoing_title_not:!isPurchaseDone(t,5)}">Em
                      Transporte
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="ongoing_subtitle_done mt-2">{{getStatusDate(5, t, true)}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mt-2">
                      <img src="https://cdnimages.opa4.store/img/fixedimg/map_img.png"
                           :style="{opacity:(isPurchaseDone(t,5)?1:0.3)}"/>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col @click="alertNoMap()" class="ongoing_link mt-2 mb-3"
                           :style="{color:(isPurchaseDone(t,5)?getCssColor('primary_bt'):'#c0c0c0')}">Visualizar Mapa
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <!-- Entregue -->
              <b-row>
                <b-col cols="1">
                  <div class="ongoing_done"
                       :style="{backgroundColor:isPurchaseDone(t, 6) ? getCssColor('primary_bt') : '#c0c0c0'}">
                    <font-awesome-icon style="font-size:8px;color:#ffffff;" :icon="['far', 'check']"/>
                  </div>
                </b-col>
                <b-col cols="10">
                  <b-row>
                    <b-col :class="{ongoing_title_done:isPurchaseDone(t,6), ongoing_title_not:!isPurchaseDone(t,6)}">
                      Entregue
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="ongoing_subtitle_done mt-2">{{getStatusDate(6, t, true)}}</b-col>
                  </b-row>
                  <b-col class="ongoing_link mt-2 mb-3">
                    <button v-if="t.Status === 6 && ratedTransactionsId.indexOf(t.Id) === -1"
                            @click="openRateModal(t)"
                            :style="{backgroundColor:getCssColor('primary_bt')}"
                            style="align-items:center; text-align: left; right: 15px;" class="solid_ongoing_bt">
                      <font-awesome-icon class="bt_icon_ongoing" style="ight: 0px; left: 5px; font-size:20px;color:#ffffff;"
                                         :icon="['far', 'star']"/>
                      <p style="text-align: center">Avalie sua experiência</p>
                    </button>
                    <button v-else :style="{backgroundColor:'#c0c0c0'}"
                            style="align-items:center; text-align: left; right: 15px;" class="solid_ongoing_bt">
                      <font-awesome-icon class="bt_icon_ongoing" style="right: 0px; left: 5px; font-size:20px;color:#ffffff;"
                                         :icon="['far', 'star']"/>
                      <p style="text-align: center">Avalie sua experiência</p>
                    </button>
                  </b-col>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <!-- open close -->
          <b-row style="height:70px; align-items:flex-end; margin-top:-100px;" class="open_close_details text-center">
            <template v-if="t.oppened">
              <b-col cols="12 mb-1" @click="closeTransaction(t)">
                <font-awesome-icon style="font-size:18px;" :icon="['far', 'chevron-up']"
                                   :style="{color:getCssColor('primary_bt')}"/>
              </b-col>
            </template>
            <template v-else>
              <b-col cols="12 mb-1" @click="openTransaction(t)">
                <font-awesome-icon style="font-size:18px;" :icon="['far', 'chevron-down']"
                                   :style="{color:getCssColor('primary_bt')}"/>
              </b-col>
            </template>
          </b-row>
        </div>
      </template>

      <OpaSlideModal style="font-family: Roboto; font-style: normal; overflow: scroll; padd" title="Avalie sua experiência" direction="down" v-model="rateModal" @slideModalClose="() => rateModal = false"
      >
        <b-container class="ratingContent" style="text-align: center; font-weight: 500;">
          <b-row class="mt-3">
            <b-col style="font-size: 19px; font-weight:bold;">{{tempRatingTransaction.company_name}}</b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col style="font-weight: bold; font-size: 18px; line-height: 18px; height: 20px;" :style="{color: getCssColor('primary_bt')}">
              Como foi sua experiência?
            </b-col>
          </b-row>
          <b-row class="mt-3 no-gutters justify-content-center">
            <b-col cols="2">
              <font-awesome-icon v-if="star1" @click="doStar(1)" :style="{color: getCssColor('primary_bt')}" style="font-size:28px;"
                                 :icon="['fas', 'star']"/>
              <font-awesome-icon v-else @click="doStar(1)" :style="{color: getCssColor('primary_bt')}" style="font-size:28px;"
                                 :icon="['fal', 'star']"/>
            </b-col>
            <b-col cols="2">
              <font-awesome-icon v-if="star2" @click="doStar(2)" :style="{color: getCssColor('primary_bt')}" style="font-size:28px;"
                                 :icon="['fas', 'star']"/>
              <font-awesome-icon v-else @click="doStar(2)" :style="{color: getCssColor('primary_bt')}" style="font-size:28px;"
                                 :icon="['fal', 'star']"/>
            </b-col>
            <b-col cols="2">
              <font-awesome-icon v-if="star3" @click="doStar(3)" :style="{color: getCssColor('primary_bt')}" style="font-size:28px;"
                                 :icon="['fas', 'star']"/>
              <font-awesome-icon v-else @click="doStar(3)" :style="{color: getCssColor('primary_bt')}" style="font-size:28px;"
                                 :icon="['fal', 'star']"/>
            </b-col>
            <b-col cols="2">
              <font-awesome-icon v-if="star4" @click="doStar(4)" :style="{color: getCssColor('primary_bt')}" style="font-size:28px;"
                                 :icon="['fas', 'star']"/>
              <font-awesome-icon v-else @click="doStar(4)" :style="{color: getCssColor('primary_bt')}" style="font-size:28px;"
                                 :icon="['fal', 'star']"/>
            </b-col>
            <b-col cols="2">
              <font-awesome-icon v-if="star5" @click="doStar(5)" :style="{color: getCssColor('primary_bt')}" style="font-size:28px;"
                                 :icon="['fas', 'star']"/>
              <font-awesome-icon v-else @click="doStar(5)" :style="{color: getCssColor('primary_bt')}" style="font-size:28px;"
                                 :icon="['fal', 'star']"/>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col style="font-weight: bold; font-size: 15px; line-height: 18px;">
              Tem algum item que pode ser melhorado?
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col v-for="(improve, idx) in toImprove" v-bind:key="idx">
              <div @click="selectToImprove(improve)" class="itemsToImprove" :style="{backgroundColor: (improve.selected ? getCssColor('primary_bt') : '#ffffff' ), color:(improve.selected ? '#ffffff' : getCssColor('primary_bt')), borderColor: getCssColor('primary_bt')}">{{improve.name}}</div>
            </b-col>
          </b-row>

          <b-row class="mt-4" style="font-style: normal; font-weight: bold; font-size: 15px; line-height: 18px;">
            <b-col cols="8" class="text-left">Deixe um comentário:</b-col>
            <b-col class="text-right">{{(comment ? comment.length : 0)}}/{{commentMaxCharacters}}</b-col>
          </b-row>
          <b-row class="mt-2" style="font-weight: normal; font-size: 13px; line-height: 18px;">
            <b-col><textarea v-model="comment" :maxlength="commentMaxCharacters" style="color: #525962; width: 264px; height: 104px; left: 0px; top: 5px; width: 100%; height: 64px; left: 45px; top: 405px; border: 1px solid; box-sizing: border-box; border-radius: 5px;" :style="{borderColor:getCssColor('primary_bt')}"></textarea></b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col style="font-style: normal; font-weight: bold; font-size: 15px;">
              Seu pedido chegou a tempo?
            </b-col>
          </b-row>
          <b-row class="mt-3 justify-content-center">
            <b-col cols="3"><input type="radio" name="orderOnTime" :value="true" v-model="shechuleTimed" style="width:24px;" /><label style="font-weight: 500; font-size: 13px;" :style="{color: getCssColor('primary_bt')}"> Sim</label></b-col>
            <b-col cols="3"><input type="radio" name="orderOnTime" :value="false" v-model="shechuleTimed" style="width:24px;"/><label style="font-weight: 500; font-size: 13px;" :style="{color: getCssColor('primary_bt')}"> Não</label></b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col style="font-style: normal; font-weight: bold; font-size: 15px;">Em uma escala de 1 a 10, qual a probabilidade de você indicar a {{$store.state.company.companyBrand}}?</b-col>
          </b-row>

          <b-row class="mt-4 no-gutters justify-content-center">
            <b-col class="bt_vote0" cols="1" @click="doScore(0)" :style="{backgroundColor: (score[0] ? getCssColor('primary_bt') : '#ffffff' ), color:(score[0] ? '#ffffff' : getCssColor('primary_bt')), borderColor: getCssColor('primary_bt')}"> 1</b-col>
            <b-col class="bt_vote" cols="1" @click="doScore(1)" :style="{backgroundColor: (score[1] ? getCssColor('primary_bt') : '#ffffff' ), color:(score[1] ? '#ffffff' : getCssColor('primary_bt')), borderColor: getCssColor('primary_bt')}">2</b-col>
            <b-col class="bt_vote" cols="1" @click="doScore(2)" :style="{backgroundColor: (score[2] ? getCssColor('primary_bt') : '#ffffff' ), color:(score[2] ? '#ffffff' : getCssColor('primary_bt')), borderColor: getCssColor('primary_bt')}">3</b-col>
            <b-col class="bt_vote" cols="1" @click="doScore(3)" :style="{backgroundColor: (score[3] ? getCssColor('primary_bt') : '#ffffff' ), color:(score[3] ? '#ffffff' : getCssColor('primary_bt')), borderColor: getCssColor('primary_bt')}">4</b-col>
            <b-col class="bt_vote" cols="1" @click="doScore(4)" :style="{backgroundColor: (score[4] ? getCssColor('primary_bt') : '#ffffff' ), color:(score[4] ? '#ffffff' : getCssColor('primary_bt')), borderColor: getCssColor('primary_bt')}">5</b-col>
            <b-col class="bt_vote" cols="1" @click="doScore(5)" :style="{backgroundColor: (score[5] ? getCssColor('primary_bt') : '#ffffff' ), color:(score[5] ? '#ffffff' : getCssColor('primary_bt')), borderColor: getCssColor('primary_bt')}">6</b-col>
            <b-col class="bt_vote" cols="1" @click="doScore(6)" :style="{backgroundColor: (score[6] ? getCssColor('primary_bt') : '#ffffff' ), color:(score[6] ? '#ffffff' : getCssColor('primary_bt')), borderColor: getCssColor('primary_bt')}">7</b-col>
            <b-col class="bt_vote" cols="1" @click="doScore(7)" :style="{backgroundColor: (score[7] ? getCssColor('primary_bt') : '#ffffff' ), color:(score[7] ? '#ffffff' : getCssColor('primary_bt')), borderColor: getCssColor('primary_bt')}">8</b-col>
            <b-col class="bt_vote" cols="1" @click="doScore(8)" :style="{backgroundColor: (score[8] ? getCssColor('primary_bt') : '#ffffff' ), color:(score[8] ? '#ffffff' : getCssColor('primary_bt')), borderColor: getCssColor('primary_bt')}">9</b-col>
            <b-col class="bt_vote1" cols="1" @click="doScore(9)" :style="{backgroundColor: (score[9] ? getCssColor('primary_bt') : '#ffffff' ), color:(score[9] ? '#ffffff' : getCssColor('primary_bt')), borderColor: getCssColor('primary_bt')}">10</b-col>
          </b-row>

          <b-row class="mt-4 no-gutters justify-content-center" style="margin-bottom: 20px;">
            <b-col cols="10" style="padding-bottom:60px;">
              <div @click="sendRating()" style="border-radius: 5px; color: #FFFFFF; height: 32px; line-height: 29px;" :style="{backgroundColor: getCssColor('primary_bt')}">Enviar</div>
            </b-col>
          </b-row>
        </b-container>

      </OpaSlideModal>

      <!-- modal detail -->
      <OpaSlideModal
        title="Detalhes do Pedido"
        direction="right"
        v-model="detailModal"
        @slideModalClose="() => detailModal = false"
      >
        <b-row v-if="tempDetail" align-h="center" style="height:calc(100vh - 66px);overflow-y:auto;overflow-x:hidden;">
          <b-col>
            <b-row class="mt-3" style="border-bottom: 1px solid #D9D9D9;">
              <b-col>Em Andamento</b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col style="font-size:15px;">Pedido #{{tempDetail.PurchaseNumber}}</b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col style="font-size:12px;"><b>Produtos Comprados:</b> R$ {{formatPrice(tempDetail.PurchaseValue)}}</b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col style="font-size:12px;"><b>Cupom de Desconto:</b> - R$ {{formatPrice(tempDetail.voucher_discount_applied)}}</b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col style="font-size:12px;"><b>Frete/Serviço:</b> R$ {{formatPrice(tempDetail.DeliveryTax + tempDetail.service_fee)}}</b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col style="font-size:12px;"><b>Total:</b> R$ {{formatPrice(tempDetail.PurchaseValue + tempDetail.DeliveryTax - tempDetail.voucher_discount_applied + tempDetail.service_fee)}}</b-col>
            </b-row>
            <b-row class="mt-3" style="border-bottom: 1px solid #D9D9D9;">
              <b-col>Produtos</b-col>
            </b-row>
            <b-row class="mt-3 product_details_header">
              <b-col cols="2">Qtd.</b-col>
              <b-col>Nome</b-col>
              <b-col cols="4" class="text-right">Preço Unitário</b-col>
            </b-row>
            <b-row class="product_details mt-2 justify-content-center align-items-center"
                   v-for="(p, idxp) in tempDetail.ProductList" v-bind:key="idxp">
              <b-col cols="2">{{p.purchased_quantity}} x</b-col>
              <b-col>
                <b>{{p.name.toLowerCase()}}</b>
                <template v-if="p.options_chosen && p.options_chosen.length">
                  <span style="font-size:10px;" v-html ="getOptionsDescription(p.options_chosen)"/>
                </template>
              </b-col>
              <b-col cols="4" class="text-right" v-if="p.product_views[0].real_price">R$ {{formatPrice(p.product_views[0].real_price)}}</b-col>
              <b-col cols="4" class="text-right" v-else-if="p.product_views[0].promotional_price">R$ {{formatPrice(p.product_views[0].promotional_price)}}</b-col>
              <b-col cols="4" class="text-right" v-else>R$ {{formatPrice(p.product_views[0].price)}}</b-col>
              <b-col class="pb-2" cols="11" style="border-bottom: 1px solid #D9D9D9;"></b-col>
            </b-row>
          </b-col>
        </b-row>
      </OpaSlideModal>


    </b-container>
    <!-- footer -->
    <b-container fluid>
      <b-row>
        <Footer/>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import InnerLoading from '@/components/InnerLoading'
  import colors from '@/mixins/colors'
  import formaters from '@/mixins/formaters'
  import HeaderBackMobile from '@/components/HeaderBackMobile.vue'
  import StoreHeader from '@/components/StoreHeader.vue'
  import Footer from '@/components/Footer.vue'
  import TransactionConn from '@/connection/transactions'
  import UserConn from '@/connection/user'
  import OpaSlideModal from '@/components/OpaSlideModal'
  import {EventBus} from '@/behaviours/event-bus'
  import RatingConn from '@/connection/rating'

  export default {
    data() {
      return {
        toImprove: [{id: 'DELIVERY_TIME', name: 'Tempo de entrega', selected: false}, {id: 'CUSTOMER_SERVICE', name: 'Atendimento da loja', selected: false}, {id: 'FOOD', name: 'Conteúdo', selected: false}, {id: 'PACKING', name: 'Embalagem', selected: false}, {id: 'WRONG_ITEMS', name: 'Itens errados', selected: false}, {id: 'MOTOBOY', name: 'Postura do entregador', selected: false}],
        transactions: [],
        loading: true,
        detailModal: false,
        tempDetail: null,
        rateModal: false,
        comment: null,
        shechuleTimed: undefined,
        commentMaxCharacters: 280,
        tempRatingTransaction: {},

        score: [false, false, false, false, false, false, false, false, false, false],

        timeoutsPurchase: [],

        star1: false,
        star2: false,
        star3: false,
        star4: false,
        star5: false,

        ratedTransactionsId: []
      }
    },

    mixins: [colors, formaters],

    components: {InnerLoading, HeaderBackMobile, StoreHeader, Footer, OpaSlideModal},

    async created() {
      if (UserConn.isLoggedIn()) {
        await this.getTransactions()
        await this.getTransactionsRating()
      } else {
        this.$store.state.registerLoginOrigin = 'ongoing'
        this.$router.push({path: '/login'})
      }
      this.loading = false
    },

    destroyed() {
      for (var i = 0; i < this.timeoutsPurchase.length; i++) {
        clearTimeout(this.timeoutsPurchase[i]);
      }
    },

    methods: {

      async getTransactions() {
        let purchases = await TransactionConn.getAll()
        if (purchases && purchases.length) {
          this.transactions = purchases.filter((p) => {
            return (p.Status === 2 || p.Status === 4 || p.Status === 5 || p.Status === 9 || p.Status === 11 || p.Status === 12) || p.Status === 6  && p.StatusDate > new Date().getTime() - (24 * 60 * 60 * 1000)
          })
          if (this.transactions.length) {
            this.transactions[0].oppened = true
            this.$forceUpdate()
          }
          this.timeoutsPurchase.push(setTimeout(async () => {
            await this.getTransactions()
          }, 15000))
        }
      },

      async getTransactionsRating() {
        let rating = await RatingConn.getAllRatingByUserId()
        if (!rating.error) {
          this.ratedTransactionsId = rating.map(rate => rate.order_id)
        }
      },

      getOptionsDescription(options) {
        let desc = '<br/>'
        options.forEach((o) => {
          o.choices.forEach((c) => {
            desc += `${c.quantity} x ${c.label} ${(c.price != null ? '+ R$ ' + this.formatPrice(c.price) : '')}`
            desc += '<br/>'
          })
        })
        return desc;
      },

      openDetails(t) {
        this.tempDetail = t
        this.detailModal = true
        console.log(this.tempDetail)
      },

      openTransaction(t) {
        t.oppened = true
        this.$forceUpdate()
      },

      closeTransaction(t) {
        delete t.oppened
        this.$forceUpdate()
      },

      alertNoMap() {
        EventBus.$emit('showAlert', 'info', 'Este entregador não possui rastreamento')
      },

      isPurchaseDone(t, status) {
        if (status === 2 && t.Status !== 12) {
          return true
        }
        if (status === 4 && t.Status >= 4 && t.Status !== 12) {
          return true
        }
        if (status === 11 && t.Status >= 5 && t.Status !== 9 && t.Status !== 12) {
          return true
        }
        if (status === 5 && t.Status >= 5 && t.Status !== 9 && t.Status !== 11 && t.Status !== 12) {
          return true
        }
        if (status === 6 && t.Status === 6) {
          return true
        }
        if (status === 9 && (t.Status === 6 || t.Status === 9)) {
          return true
        }
        return false
      },

      getStatusDate(status, t, datetime) {
        if (t && t.StatusHistory) {
          let hstatus = t.StatusHistory.filter(s => s.status === status)
          if (hstatus.length) {
            if (!datetime) {
              return this.formatDate(hstatus[0].statusDate)
            } else {
              return this.formatDateTime(hstatus[0].statusDate)
            }
          }
        }
        return ''
      },

      openRateModal(t) {
        this.clearRating()
        this.tempRatingTransaction = t
        if (this.isPurchaseDone(t, 6)) {
          this.rateModal = true
        }
      },

      doStar(stars) {
        if (stars === 1) {
          this.star1 = true
          this.star2 = false
          this.star3 = false
          this.star4 = false
          this.star5 = false
        } else if (stars === 2) {
          this.star1 = true
          this.star2 = true
          this.star3 = false
          this.star4 = false
          this.star5 = false
        } else if (stars === 3) {
          this.star1 = true
          this.star2 = true
          this.star3 = true
          this.star4 = false
          this.star5 = false
        } else if (stars === 4) {
          this.star1 = true
          this.star2 = true
          this.star3 = true
          this.star4 = true
          this.star5 = false
        } else if (stars === 5) {
          this.star1 = true
          this.star2 = true
          this.star3 = true
          this.star4 = true
          this.star5 = true
        }
      },

      getRating() {
        if (this.star5) {
          return 5
        }
        if (this.star4) {
          return 4
        }
        if (this.star3) {
          return 3
        }
        if (this.star2) {
          return 2
        }
        if (this.star1) {
          return 1
        }
        return 0
      },

      doScore(score) {
        for (let x = 0; x < this.score.length; x++) {
          if (score === x) {
            this.score[x] = true
          } else {
            this.score[x] = false
          }
        }
        this.$forceUpdate()
      },

      selectToImprove(obj) {
        for (let x = 0; x < this.toImprove.length; x++) {
          if (this.toImprove[x].id === obj.id) {
            this.toImprove[x].selected = !this.toImprove[x].selected
            break
          }
        }
        this.$forceUpdate()
      },

      async sendRating() {
        let verify = this.verifyRating()
        if (!verify) {
          return
        }
        this.$store.state.showLoading = true
        let improvementTagList = this.toImprove.filter(i => i.selected).map(i => i.id)
        let scoreRating = this.score.indexOf(true) + 1
        let result = await RatingConn.sendRating(this.tempRatingTransaction.Id, this.getRating(), improvementTagList, this.comment, this.shechuleTimed, scoreRating)

        if (!result.error) {
          this.ratedTransactionsId.push(this.tempRatingTransaction.Id)
          EventBus.$emit('showAlert', 'success', "Obrigado pela avaliação :)")
          this.$store.state.showLoading = false
          this.rateModal = false
        } else {
          this.$store.state.showLoading = false
          EventBus.$emit('showAlert', 'error', result.msg)
        }
        this.$store.state.showLoading = false
      },

      verifyRating() {
        if (!this.star1) {
          this.$store.state.showLoading = false
          EventBus.$emit('showAlert', 'warning', 'Campo "Como foi sua experiência" não está preenchido')
          return false
        }
        if (this.shechuleTimed === undefined) {
          this.$store.state.showLoading = false
          EventBus.$emit('showAlert', 'warning', 'Campo "Seu pedido chegou a tempo?" não está preenchido')
          return false
        }
        let scoreBoolean = this.score.filter(score => score)
        if (!scoreBoolean.length) {
          this.$store.state.showLoading = false
          EventBus.$emit('showAlert', 'warning', 'Campo "Probabilidade de indicar" não está preenchido')
          return false
        }
        return true
      },

      clearRating() {
        this.toImprove.forEach((improve) => {
          improve.selected = false
        })
        this.star1 = false
        this.star2 = false
        this.star3 = false
        this.star4 = false
        this.star5 = false
        this.comment = null
        this.shechuleTimed = undefined
        this.score = [false, false, false, false, false, false, false, false, false, false]
      }
    }
  }
</script>

<style lang="scss">
  .ongoing_title {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
    letter-spacing: 0.15px;
    color: #171D33;
  }

  .ongoing_box_openned {
    margin-top: 18px;
    box-shadow: 0px 4px 20px rgba(18, 28, 42, 0.08);
    padding-bottom: 60px;
    margin-bottom: 30px;
  }

  .ongoing_box_closed {
    margin-top: 18px;
    box-shadow: 0px 4px 20px rgba(18, 28, 42, 0.08);
    height: 160px;
    margin-bottom: 30px;
    overflow: hidden;
  }

  .ongoing_title_done {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #000000;
  }

  .ongoing_title_not {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #4e4e4e;
  }

  .ongoing_subtitle_done {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #000000;
  }

  .ongoing_done {
    width: 18px;
    height: 18px;
    border-radius: 9px;
    text-align: center;
    line-height: 14px;
  }

  .ongoing_link {
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.4px;
    text-decoration-line: underline;
  }

  .lined {
    background: linear-gradient(#E6E6E6, #E6E6E6) no-repeat 23px/2px 100%;
  }

  .solid_ongoing_bt {
    border: 0px;
    border-radius: 5px;
    height: 29px;
    color: #ffffff;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 29px;
    padding: 0 8px;
    position: relative;
    width: 210px;
    text-align: left;
  }

  .bullet_chat {
    position: absolute;
    right: 3px;
    top: 3px;
    width: 12px;
    height: 12px;
    border-radius: 6px;
    background-color: #F90F0F;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    font-size: 8px;
    text-align: center;
    line-height: 13px;
  }

  .bt_icon_ongoing {
    position: absolute;
    right: 5px;
    top: 5px;
  }

  .open_close_details {
    position: relative;
    cursor: pointer;
    background: linear-gradient(180.33deg, rgba(255, 255, 255, 0.02) -5.92%, #ffffff 47.84%);
    margin-bottom: 30px;
  }

  .product_details {
    font-size: 12px;

  }

  .product_details_header {
    font-size: 12px;
    font-weight: 500;
  }

  .bt_vote0 {
    border: 1px solid;
    border-radius: 5px 0 0 5px;
    border-right: none;
  }

  .bt_vote {
    border-top: 1px solid;
    border-bottom: 1px solid;
    border-left: 1px solid;
  }

  .bt_vote1 {
    border: 1px solid;
    border-radius: 0px 5px 5px 0px;
  }

  .ratingContent {
    text-align: center;
  }

  .itemsToImprove {
    padding: 3px 8px 3px 8px;
    margin: 5px 0 5px 0;
    white-space: nowrap;
    background: #DADADA;
    border-radius: 5px;
    min-height: 19px;
    font-size: 12px;
    border: 1px solid;
  }

  .no-gutters {
    margin-right: 0;
    margin-left: 0;

    > .col,
    > [class*="col-"] {
      padding-right: 0;
      padding-left: 0;
    }
  }

  .votes {
    box-sizing: border-box;
    border-radius: 5px;
  }

</style>
